import { createSelector } from 'reselect'

import { selectCockpitKeyInitiatives } from './selectCockpitKeyInitiatives'
import { selectCockpitMode } from './selectCockpitMode'
import { selectVisibleCockpitPartnerData } from './selectVisibleCockpitPartnerData'

export const selectVisibleCockpitKeyInitiatives = createSelector(
  [selectCockpitMode, selectCockpitKeyInitiatives, selectVisibleCockpitPartnerData],
  (cockpitMode, initiatives, visiblePartners) => {
    if (cockpitMode === 'partner') {
      return initiatives
    }

    const partnerIds = new Set(visiblePartners.map(({ PartnerId }) => PartnerId))
    return initiatives.filter(({ PartnerId }) => partnerIds.has(PartnerId))
  }
)
